import { Gamepad2, Trophy, Flame, CalendarClock, Inbox, Gift } from "lucide-react";

const Kpi = ({ icon: Icon, label, value, hint, tone = "", testId }) => (
  <div className={`rounded-2xl border border-border bg-card p-4 flex items-start gap-3 ${tone}`} data-testid={testId}>
    <div className="h-9 w-9 rounded-xl bg-primary/10 text-primary grid place-items-center shrink-0"><Icon className="h-4 w-4" /></div>
    <div className="min-w-0"><p className="font-display font-bold text-2xl leading-none tabular-nums">{value}</p><p className="text-xs text-muted-foreground mt-1 truncate">{label}</p>{hint && <p className="text-[11px] text-muted-foreground/80 truncate">{hint}</p>}</div>
  </div>
);

export function DashboardKpis({ contests, counts, isAdmin }) {
  if (!contests.length) return null;
  const active = contests.filter((c) => c.status === "Attivo");
  const plays = contests.reduce((s, c) => s + (c.plays_today || 0), 0);
  const wins = contests.reduce((s, c) => s + (c.wins_today || 0), 0);
  const prizes = contests.reduce((s, c) => s + (c.prize_types || 0), 0);
  const next = [...contests].filter((c) => c.status !== "Concluso").sort((a, b) => new Date(a.end_datetime) - new Date(b.end_datetime))[0];
  const days = next ? Math.max(0, Math.ceil((new Date(next.end_datetime) - Date.now()) / 86400000)) : null;
  const hot = [...active].sort((a, b) => (b.plays_today || 0) - (a.plays_today || 0))[0];
  const pending = (counts?.demo || 0) + (counts?.support || 0);
  return (
    <section className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3 mb-8" data-testid="dashboard-kpis">
      <Kpi icon={Trophy} label="Concorsi attivi" value={active.length} hint={`${contests.length} totali`} testId="kpi-active" />
      <Kpi icon={Gamepad2} label="Giocate oggi" value={plays} hint={hot?.plays_today ? `Top: ${hot.name}` : "Nessuna giocata finora"} testId="kpi-plays" />
      <Kpi icon={Gift} label="Vincite oggi" value={wins} hint={plays ? `${Math.round(wins * 100 / plays)}% delle giocate` : null} testId="kpi-wins" />
      <Kpi icon={Flame} label="Premi in catalogo" value={prizes} hint="su tutti i concorsi" testId="kpi-prizes" />
      <Kpi icon={CalendarClock} label="Prossima scadenza" value={days == null ? "—" : `${days} gg`} hint={next?.name} testId="kpi-next-end" />
      {isAdmin && <Kpi icon={Inbox} label="Da gestire" value={pending} hint={pending ? `${counts.demo} demo · ${counts.support} support` : "Tutto in ordine"} tone={pending ? "border-amber-300 bg-amber-50/60" : ""} testId="kpi-pending" />}
    </section>
  );
}
